import { useEffect } from 'react';
import './AboutPage.scss';
import Navbar from '../../components/CommonComponents/Navbar/Navbar';
import Footer from '../../components/CommonComponents/Footer/Footer';
import AboutPageNewLandingSection from '../../components/PageComponents/AboutPageComponents/AboutPageNewLandingSection';
import AboutPageOurStory from '../../components/PageComponents/AboutPageComponents/AboutPageOurStory';
import AboutUsPageFoundersSection from '../../components/PageComponents/AboutPageComponents/AboutUsPageFoundersSection';
import AboutUsPageManifesto from '../../components/PageComponents/AboutPageComponents/AboutUsPageManifesto';
import AboutUsPageNumbersSection from '../../components/PageComponents/AboutPageComponents/AboutUsPageNumbersSection';
import AboutUsPageCTASection from '../../components/PageComponents/AboutPageComponents/AboutUsPageCTASection';
import AboutPageQuote from '../../components/PageComponents/AboutPageComponents/AboutPageQuote';

const AboutPage = () => {

  useEffect(() => {
    document.title = "GenieGig | About Us";
    window.scrollTo(0,0);
  }, []);

  return (
    <div className="about-page">
      <Navbar />
      <AboutPageNewLandingSection />
      <AboutPageOurStory />
      <AboutUsPageFoundersSection />
      <AboutUsPageManifesto />
      <AboutUsPageNumbersSection />
      <AboutPageQuote />
      <AboutUsPageCTASection />
      <Footer />
    </div>
  );
};

export default AboutPage;
